// Evolutndetails.js
import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import ExternalLayout from '../../customComponents/ExternalLayout/ExternalLayout';
import RenderPage from '../../customComponents/RenderPage/RenderPage';
import Strip from '../../customComponents/Strip/Strip';
import {
    useWindowSize
  } from '@react-hook/window-size';
import application_contants from '../../contants/application_contants';
import ImageViewer from '../../customComponents/ImageViewer/ImageViewer'
import GalleryData from '../../Utils/json/GalleryData';
import SEOComponent from '../../customComponents/SEO/SEOComponent';


import Sentaudio from './Sentaudio';

import audio10m from "../../assets/media1/s0_male.wav";
import audio20m from "../../assets/media2/s0_male.wav";
import audio20f from "../../assets/media2/s0_female.wav";
import audio21m from "../../assets/media2/s1_male.wav";
import audio21f from "../../assets/media2/s1_female.wav";
import audio22m from "../../assets/media2/s2_male.wav";
import audio22f from "../../assets/media2/s2_female.wav";
import audio23m from "../../assets/media2/s3_male.wav";
import audio23f from "../../assets/media2/s3_female.wav";
import audio24m from "../../assets/media2/s4_male.wav";
import audio24f from "../../assets/media2/s4_female.wav";
import audio30m from "../../assets/media3/s0_male.wav";
import audio31m from "../../assets/media3/s1_male.wav";
import audio32m from "../../assets/media3/s2_male.wav";
import audio33m from "../../assets/media3/s3_male.wav";
import audio34m from "../../assets/media3/s4_male.wav"; 
import audio40m from "../../assets/media4/s0_male.wav";
import audio40f from "../../assets/media4/s0_female.wav";
import audio41m from "../../assets/media4/s1_male.wav";
import audio41f from "../../assets/media4/s1_female.wav";
import audio42m from "../../assets/media4/s2_male.wav";
import audio42f from "../../assets/media4/s2_female.wav";
import audio43m from "../../assets/media4/s3_male.wav";
import audio43f from "../../assets/media4/s3_female.wav";
import audio44m from "../../assets/media4/s4_male.wav";
import audio44f from "../../assets/media4/s4_female.wav";
import audio50m from "../../assets/media5/s0_male.wav";
import audio50f from "../../assets/media5/s0_female.wav";
import audio51m from "../../assets/media5/s1_male.wav";
import audio51f from "../../assets/media5/s1_female.wav";
import audio52m from "../../assets/media5/s2_male.wav";
import audio52f from "../../assets/media5/s2_female.wav";
import audio53m from "../../assets/media5/s3_male.wav";
import audio53f from "../../assets/media5/s3_female.wav";
import audio54m from "../../assets/media5/s4_male.wav";
import audio54f from "../../assets/media5/s4_female.wav";
import audio60f from "../../assets/media6/s0_female.wav";
import audio70f from "../../assets/media7/s0_female.wav";
import audio71f from "../../assets/media7/s1_female.wav";
import audio72f from "../../assets/media7/s2_female.wav";
import audio73f from "../../assets/media7/s3_female.wav";
import audio74f from "../../assets/media7/s4_female.wav";
import audio80f from "../../assets/media8/s0_female.wav";
import audio81f from "../../assets/media8/s1_female.wav";
import audio82f from "../../assets/media8/s2_female.wav";
import audio83f from "../../assets/media8/s3_female.wav";
import audio84f from "../../assets/media8/s4_female.wav";



const sentences = {
  1: 'Dearest creature in Creation, Studying English pronunciation, I will teach you in my verse Sounds like corpse, corps, horse and worse. It will keep you, Susy, busy, Make your head with heat grow dizzy.',
  2: 'Dearest creature in Creation, Studying English pronunciation, I will teach you in my verse Sounds like corpse, corps, horse and worse. It will keep you, Susy, busy, Make your head with heat grow dizzy.',
  3: 'Regarded as a continuation of the Klein Erlangen Programme, in the sense that a geometrical space with its group of transformations is generalized to a category with its algebra of mappings.',
  4: 'Regarded as a continuation of the Klein Erlangen Programme, in the sense that a geometrical space with its group of transformations is generalized to a category with its algebra of mappings.',
  5: 'Bust of Herodotus in Stoa of Attalus, one of the earliest nameable historians whose work survives.',
  6: 'Bust of Herodotus in Stoa of Attalus, one of the earliest nameable historians whose work survives.',
  7: 'James Watson and Francis Crick determined the structure of DNA in 1953, using the X-ray crystallography work of Rosalind Franklin and Maurice Wilkins that indicated DNA has a helical structure',
  8: 'James Watson and Francis Crick determined the structure of DNA in 1953, using the X-ray crystallography work of Rosalind Franklin and Maurice Wilkins that indicated DNA has a helical structure',
  9: 'These early attempts to understand microscopic phenomena, now known as the "old quantum theory", led to the full development of quantum mechanics in the mid-1920s by Niels Bohr, Erwin Schrödinger, Werner Heisenberg, Max Born, and others.',
  10: 'These early attempts to understand microscopic phenomena, now known as the "old quantum theory", led to the full development of quantum mechanics in the mid-1920s by Niels Bohr, Erwin Schrödinger, Werner Heisenberg, Max Born, and others.',
};

const Evolutndetails = () =>{
  const [width] = useWindowSize();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
  const [selectedValue, setSelectedValue] = useState('');

  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <ExternalLayout>
            <RenderPage
                id="tst-Partners"
                className="strip render-page px-0"
                containerType="container-fluid"
            >
             <SEOComponent
                    title="Evolution of Tools"
                    keywords="SYnthesizing SPeech in INdian languages"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/evolution-of-tools" />
                <Strip
                    id="tst-strip-funding"
                    className="strip strip-no-padding px-0"
                    containerType="container"
                >
               
                    <Row className="mx-0  pt-5">  
                         {width <= application_contants.MOBILE_BREAKPOINT ? <h5 className="h5-medium section-title title-navy-blue jostRegular pb-4 align-left"> Evolution of Tools</h5> :
                                <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Evolution of Tools</h5>}
                          {/* <div >  */}
                          {/* <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pb-5">
                        <h2 className="h5-small section-title align-left pt-2 title-navy-blue-medium">Coming soon ...</h2>
                        </Col> */}
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pb-4 pt-2">
                                <h1 className="evltl-h1">Evolution of Text-to-Speech</h1>
                               
                                <div className="dropdown-container" >
                                  <select id="sentenceDropdown" onChange={handleDropdownChange} value={selectedValue}>
                                    <option value="">Select Sentence</option>
                                    <option value="1">Sentence 1</option>
                                    <option value="2">Sentence 2</option>
                                    <option value="3">Sentence 3</option>
                                    <option value="4">Sentence 4</option>
                                    <option value="5">Sentence 5</option>
                                    <option value="6">Sentence 6</option>
                                    <option value="7">Sentence 7</option>
                                    <option value="8">Sentence 8</option>
                                    <option value="9">Sentence 9</option>
                                    <option value="10">Sentence 10</option>
                                  </select>
                                </div>


<div className="timeline">

	{/* 1970 Year */}
	<div className="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
		<div className="timeline__event__icon "> </div>
		<div className="timeline__event__date">
			1970s
		</div>
		<div className="timeline__event__content ">
			<div className="timeline__event__title">
				GNU speech: Articulatory
			</div>
			<div className="timeline__event__description">
          <p>This is the oldest technique of speech synthesis, in which we
              try to synthesize speech by modeling the human speech
              production mechanisms as perfectly as possible. This is the
              most complicated among all the techniques and practically
              does not generate intelligible speech. GNU speech is the open-
              source tool that uses 'resonance tube model' to synthesize
              speech.</p>

          {selectedValue === '1' && (
          <div>
            <Sentaudio sentence={sentences[1]} gender="Male" audioFile={audio10m} />
          </div>
          )}
        </div>
    </div>
  </div>

  {/* 1980 Year */}
	<div className="timeline__event animated fadeInUp delay-2s timeline__event--type2">
		<div className="timeline__event__icon "> </div>
		<div className="timeline__event__date">
			1980s
		</div>
		<div className="timeline__event__content ">
			<div className="timeline__event__title">
        eSpeak: Formant synthesis
			</div>
			<div className="timeline__event__description">
          <p>This was the first speech synthesis techniques that generated
              speech of acceptable intelligibility and dominated the field in
              1970-1990. It is based on the source-filter model which means
              that the idea is to generate artificial spectrograms by feeding
              periodic and non-periodic source signals through a resonator
              circuit – or a filter – that models the vocal tract. Generally,
              three lowest formants are taken into account to generating
              intelligible speech. eSpeak is the open-source tool that uses
              this technique.</p>

          {selectedValue === '1' && (
          <div>
            <Sentaudio sentence={sentences[1]} gender="Male" audioFile={audio20m} />
          </div>
          )}
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio20f} />
          </div>
          )}
          {selectedValue === '3' && (
          <div>
            <Sentaudio sentence={sentences[3]} gender="Male" audioFile={audio21m} />
          </div>
          )}
          {selectedValue === '4' && (
          <div>
            <Sentaudio sentence={sentences[4]} gender="Female" audioFile={audio21f} />
          </div>
          )}
          {selectedValue === '5' && (
          <div>
            <Sentaudio sentence={sentences[5]} gender="Male" audioFile={audio22m} />
          </div>
          )}
          {selectedValue === '6' && (
          <div>
            <Sentaudio sentence={sentences[6]} gender="Female" audioFile={audio22f} />
          </div>
          )}
          {selectedValue === '7' && (
          <div>
            <Sentaudio sentence={sentences[7]} gender="Male" audioFile={audio23m} />
          </div>
          )}
          {selectedValue === '8' && (
          <div>
            <Sentaudio sentence={sentences[8]} gender="Female" audioFile={audio23f} />
          </div>
          )}
          {selectedValue === '9' && (
          <div>
            <Sentaudio sentence={sentences[9]} gender="Male" audioFile={audio24m} />
          </div>
          )}
          {selectedValue === '10' && (
          <div>
            <Sentaudio sentence={sentences[10]} gender="Female" audioFile={audio24f} />
          </div>
          )}
        </div>
    </div>
  </div>

  {/* 1990 Year */}
	<div className="timeline__event animated fadeInUp delay-1s timeline__event--type3">
		<div className="timeline__event__icon "> </div>
		<div className="timeline__event__date">
			1990s
		</div>
		<div className="timeline__event__content ">
			<div className="timeline__event__title">
        Concatenative synthesis: Diphone based concatenation
			</div>
			<div className="timeline__event__description">
          <p>This is a database-based speech synthesis method, where short speech segments are selected from a pre-recorded database and joined to produce desired utterances. Concatenative TTS improved significantly in the 1980s-1990s, mainly due to techniques like Pitch Synchronous Overlap and Add, enhancing speech prosody. It became the most popular speech synthesis method in the 1990s. Festival speech synthesis uses concatenative synthesis, utilizing diaphones as units of speech, preserving natural transitions between phones.
          </p>

          {selectedValue === '1' && (
          <div>
            <Sentaudio sentence={sentences[1]} gender="Male" audioFile={audio30m} />
          </div>
          )}
          {selectedValue === '3' && (
          <div>
            <Sentaudio sentence={sentences[3]} gender="Male" audioFile={audio31m} />
          </div>
          )}
          {selectedValue === '5' && (
          <div>
            <Sentaudio sentence={sentences[5]} gender="Male" audioFile={audio32m} />
          </div>
          )}
          {selectedValue === '7' && (
          <div>
            <Sentaudio sentence={sentences[7]} gender="Male" audioFile={audio33m} />
          </div>
          )}
          {selectedValue === '9' && (
          <div>
            <Sentaudio sentence={sentences[9]} gender="Male" audioFile={audio34m} />
          </div>
          )}
        </div>
    </div>
  </div>

  {/* 1990 Year */}
	<div className="timeline__event animated fadeInUp timeline__event--type1">
		<div className="timeline__event__icon"> </div>
		<div className="timeline__event__date">
			1990s
		</div>
		<div className="timeline__event__content">
			<div className="timeline__event__title">
				Concatenative synthesis: Unit-selection based concatenation
			</div>
			<div className="timeline__event__description">
          <p>This is a database-based speech synthesis method, where short speech segments are selected from a pre-recorded database and concatenated to form desired utterances. Concatenative TTS improved significantly in the 1980s-1990s, mainly due to techniques like Pitch Synchronous Overlap and Add, enhancing speech prosody. It became the most popular speech synthesis method in the 1990s. Festival speech synthesis relies on the concatenative approach, segmenting the database into various units, including diaphones, half-phones, and words. These units are indexed based on acoustic parameters like pitch, duration, and position in the syllable. During runtime, the best-matched unit is chosen for concatenation, resulting in natural-sounding speech, especially in the 1990s.
          </p>

          {selectedValue === '1' && (
          <div>
            <Sentaudio sentence={sentences[1]} gender="Male" audioFile={audio40m} />
          </div>
          )}
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio40f} />
          </div>
          )}
          {selectedValue === '3' && (
          <div>
            <Sentaudio sentence={sentences[3]} gender="Male" audioFile={audio41m} />
          </div>
          )}
          {selectedValue === '4' && (
          <div>
            <Sentaudio sentence={sentences[4]} gender="Female" audioFile={audio41f} />
          </div>
          )}
          {selectedValue === '5' && (
          <div>
            <Sentaudio sentence={sentences[5]} gender="Male" audioFile={audio42m} />
          </div>
          )}
          {selectedValue === '6' && (
          <div>
            <Sentaudio sentence={sentences[6]} gender="Female" audioFile={audio42f} />
          </div>
          )}
          {selectedValue === '7' && (
          <div>
            <Sentaudio sentence={sentences[7]} gender="Male" audioFile={audio43m} />
          </div>
          )}
          {selectedValue === '8' && (
          <div>
            <Sentaudio sentence={sentences[8]} gender="Female" audioFile={audio43f} />
          </div>
          )}
          {selectedValue === '9' && (
          <div>
            <Sentaudio sentence={sentences[9]} gender="Male" audioFile={audio44m} />
          </div>
          )}
          {selectedValue === '10' && (
          <div>
            <Sentaudio sentence={sentences[10]} gender="Female" audioFile={audio44f} />
          </div>
          )}
        </div>
    </div>
  </div>
  
  {/* 2005 Year */}
	<div className="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
		<div className="timeline__event__icon "> </div>
		<div className="timeline__event__date">
			2005
		</div>
		<div className="timeline__event__content ">
			<div className="timeline__event__title">
      Machine learning model: HMM based synthesis
			</div>
			<div className="timeline__event__description">
          <p> This machine learning or statistical model entered the field
              of Speech synthesis in 2005 with Hidden Markov Model -
              HMM based synthesis which proved quite effective. In this
              system, the frequency spectrum (for vocal tract), fundamental
              frequency (for voice source), and duration of speech are
              modeled simultaneously by HMMs. Speech waveforms are
              generated from HMMs themselves based on the maximum
              likelihood criterion such as in HTS tool. This technique is for
              wave-form generation and it relies on other tools for text
              processing and generation of linguistic features.
          </p>

          {selectedValue === '1' && (
          <div>
            <Sentaudio sentence={sentences[1]} gender="Male" audioFile={audio50m} />
          </div>
          )}
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio50f} />
          </div>
          )}
          {selectedValue === '3' && (
          <div>
            <Sentaudio sentence={sentences[3]} gender="Male" audioFile={audio51m} />
          </div>
          )}
          {selectedValue === '4' && (
          <div>
            <Sentaudio sentence={sentences[4]} gender="Female" audioFile={audio51f} />
          </div>
          )}
          {selectedValue === '5' && (
          <div>
            <Sentaudio sentence={sentences[5]} gender="Male" audioFile={audio52m} />
          </div>
          )}
          {selectedValue === '6' && (
          <div>
            <Sentaudio sentence={sentences[6]} gender="Female" audioFile={audio52f} />
          </div>
          )}
          {selectedValue === '7' && (
          <div>
            <Sentaudio sentence={sentences[7]} gender="Male" audioFile={audio53m} />
          </div>
          )}
          {selectedValue === '8' && (
          <div>
            <Sentaudio sentence={sentences[8]} gender="Female" audioFile={audio53f} />
          </div>
          )}
          {selectedValue === '9' && (
          <div>
            <Sentaudio sentence={sentences[9]} gender="Male" audioFile={audio54m} />
          </div>
          )}
          {selectedValue === '10' && (
          <div>
            <Sentaudio sentence={sentences[10]} gender="Female" audioFile={audio54f} />
          </div>
          )}
        </div>
    </div>
  </div>

  {/* 2015 Year */}
	<div className="timeline__event animated fadeInUp delay-2s timeline__event--type2">
		<div className="timeline__event__icon"> </div>
		<div className="timeline__event__date">
			2015
		</div>
		<div className="timeline__event__content">
			<div className="timeline__event__title">
          Deep learning models
			</div>
			<div className="timeline__event__description">
          <p>In this technique, the parameters involved in mapping
              linguistic features to acoustic features are learnt through deep
              neural network.'Merlin' toolkit is based on deep learning
              based speech synthesis. This technique relies on other tools,
              such as Festival for linguistic feature generation and 'World'
              vocoder to generate wave-form from acoustic features.
          </p>
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio60f} />
          </div>
          )}
        </div>
    </div>
  </div>

  {/* 2018 Year */}
	<div className="timeline__event animated fadeInUp delay-1s timeline__event--type3">
		<div className="timeline__event__icon"> </div>
		<div className="timeline__event__date">
			2018
		</div>
		<div className="timeline__event__content">
			<div className="timeline__event__title">
          Semi end-to-end speech synthesis models
			</div>
			<div className="timeline__event__description">
          <p> Tacotron-1/2, Fastspeech-1/2, Deepvoice, Char2wav are the
              tools that combine the linguistic feature generation and
              linguistic to acoustic feature mapping into one deep neural
              network unit. They generate linear/Mel spectrogram
              directly from the text using deep sequential neural networks:
              RNNs and their variants. When comparing with typical TTS
              systems, these perform both the frontend and backend
              processing in one model. However, they generate only
              acoustic parameters and depend on vocoder to generate
              waveforms
          </p>
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio70f} />
          </div>
          )}
          {selectedValue === '4' && (
          <div>
            <Sentaudio sentence={sentences[4]} gender="Female" audioFile={audio71f} />
          </div>
          )}
          {selectedValue === '6' && (
          <div>
            <Sentaudio sentence={sentences[6]} gender="Female" audioFile={audio72f} />
          </div>
          )}
          {selectedValue === '8' && (
          <div>
            <Sentaudio sentence={sentences[8]} gender="Female" audioFile={audio73f} />
          </div>
          )}
          {selectedValue === '10' && (
          <div>
            <Sentaudio sentence={sentences[10]} gender="Female" audioFile={audio74f} />
          </div>
          )}
        </div>
    </div>
  </div>

   {/* 2021 Year */}
   <div className="timeline__event animated fadeInUp timeline__event--type1">
		<div className="timeline__event__icon"> </div>
		<div className="timeline__event__date">
			2021
		</div>
		<div className="timeline__event__content">
			<div className="timeline__event__title">
          End-to-end models
			</div>
			<div className="timeline__event__description">
          <p>These models exhibit the most recent trend in speech
              synthesis systems, i.e., generating speech waveforms directly
              from the text without generating any intermediary acoustic
              feature. These models are essentially based on generative
              adversarial network training. Fastspeech-2s(2021) and
              EATS(End to end adversarial text to speech)(2021) are the
              two examples of end to end models.
          </p>
          {selectedValue === '2' && (
          <div>
            <Sentaudio sentence={sentences[2]} gender="Female" audioFile={audio80f} />
          </div>
          )}
          {selectedValue === '4' && (
          <div>
            <Sentaudio sentence={sentences[4]} gender="Female" audioFile={audio81f} />
          </div>
          )}
          {selectedValue === '6' && (
          <div>
            <Sentaudio sentence={sentences[6]} gender="Female" audioFile={audio82f} />
          </div>
          )}
          {selectedValue === '8' && (
          <div>
            <Sentaudio sentence={sentences[8]} gender="Female" audioFile={audio83f} />
          </div>
          )}
          {selectedValue === '10' && (
          <div>
            <Sentaudio sentence={sentences[10]} gender="Female" audioFile={audio84f} />
          </div>
          )}
        </div>
    </div>
  </div>

     


        
    </div>

    </Col>
    </Row>
    </Strip>
            </RenderPage>
         </ExternalLayout>
    

  );
}

export default Evolutndetails;
